import { useMutation } from '@tanstack/react-query';
import { updateWorkingStatusFx } from '../../effects';

export const useUpdateWorkingStatus = () => {
    return useMutation({
        mutationFn: updateWorkingStatusFx,
    });
};
